import { useEffect } from "react";
import { useLocation } from "wouter";
import { useQueryClient } from "@tanstack/react-query";
import { CheckCircle2 } from "lucide-react";

export default function ThankYouPage() {
  const [, setLocation] = useLocation();
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ["/api/auth/user"] });
  }, [queryClient]);

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const fbEventId = params.get("fb_event_id") || undefined;
      const value = params.get("value");
      const currency = params.get("currency");

      const customData: Record<string, unknown> = {};
      if (value) customData.value = Number(value);
      if (currency) customData.currency = currency;

      if (fbEventId) {
        (window as any).fbq("track", "Subscribe", customData, { eventID: fbEventId });
      } else {
        (window as any).fbq("track", "Subscribe", customData);
      }
    } catch (_) {}
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLocation("/dashboard");
    }, 4000);
    return () => clearTimeout(timer);
  }, [setLocation]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
            <CheckCircle2 className="h-10 w-10 text-primary" />
          </div>
        </div>
        <h1 className="text-3xl font-bold mb-3">You're all set!</h1>
        <p className="text-muted-foreground text-lg mb-2">
          Your subscription is now active.
        </p>
        <p className="text-muted-foreground text-sm">
          Taking you to your dashboard in a moment...
        </p>
        <div className="mt-8 flex justify-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-primary animate-bounce [animation-delay:0ms]" />
          <span className="w-2 h-2 rounded-full bg-primary animate-bounce [animation-delay:150ms]" />
          <span className="w-2 h-2 rounded-full bg-primary animate-bounce [animation-delay:300ms]" />
        </div>
      </div>
    </div>
  );
}
